<template>
  <div
    class="cpt-chat-form-button flex-center wh-full bg-bd-fl rounded-[3px] text-[14px] text-wh-0 leading-[18px] pointer"
    :class="[type, {loading, disabled, success}]"
    @click="handleClick"
  >
    <i 
      v-if="icon"
      class="iconfont"
      :class="icon"
      :style="{'margin-right': text ? '3px' : ''}"
    ></i>
    <i
      class="iconfont icon-correct-bold"
      v-if="success"
      :style="{'margin-right': text ? '3px' : ''}"
    ></i>
    <div
      v-if="loading"
      class="loading wh-16 relative rounded-full mr-[6px]"
    ></div>
      {{ text }}
    <i 
      v-if="suffixIcon"
      class="iconfont suffix"
      :class="suffixIcon"
    ></i>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: {
    icon: {
      default: "",
      type: String,
    },
    suffixIcon: {
      default: "",
      type: String,
    },
    text: {
      default: "",
      type: String,
    },
    type: {
      default: "",
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    success: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick(e) {
      if (this.disabled) return;
      this.$emit('click', e);
    }
  }
};
</script>

<style lang="scss">
.cpt-chat-form-button {
  i {
    width: 12px;
    height: 12px;
    font-size: 12px;
  }
  &.cancel {
    background: $d-fl-btn;
    color: $d-tx-1;
  }
  &.disabled {
    background: $d-bd-fl;
    color: $ct-wh-0;
    cursor: not-allowed;
    opacity: .4;
  }
  &.alert {
    background-color: $d-er-fl;
  }
  &.transparent {
    background: $d-op-2;
    color: $d-tx-1;
  }
  &.gradient {
    color: $d-tx-1;
    background: $d-bg-ln-3;
  }
  &.loading {
    opacity: 0.4;
    cursor: not-allowed;
  }
  &.primary {
    background: $d-bg-ln-3;
  }
  &.agreed {
    background: $d-fl-sl;
    color: $d-bd-tx;
  }
  .icon-correct-bold {
    margin-right: 3px;
  }
  .suffix {
    margin-left: 3px;
  }
  .loading {
    border: 2px solid $d-op-3;
    &::after {
      content: '';
      border: 2px solid transparent;
      border-left: 2px solid $d-bd-tx;
      border-radius: 50%;
      position: absolute;
      top: -2px;
      left: -2px;
      bottom: -2px;
      right: -2px;
      animation: rotate 1s infinite linear;
    }
  }
}
</style>
